// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YAtmS","text":"styles_text__waf5O"};